/*
 * @Descripttion:
 * @version:
 * @Author: lxh3@meitu.com
 * @Date: 2025-05-24 21:30:28
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-06-24 14:02:00
 */
import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';
import {
  FabricObject, isRealElement,
} from '@meitu/whee-infinite-canvas';

interface TLayerState {
  layers: FabricObject[];
  isEmptyLayers(): boolean;
}

const Slice: StateCreator<TLayerState, [
  ['zustand/immer', never],
]> = (_, get) => ({
  layers: [],
  isEmptyLayers() { return get().layers.length === 0; },
});

// @ts-ignore
const useLayerStore: UseBoundStore<StoreApi<TLayerState>> = create<TLayerState>()(immer(Slice));

export default useLayerStore;

export function setLayers(layers: FabricObject[]) {
  // 过滤真图层
  const _layers: FabricObject[] = layers.filter((el) => isRealElement(el));
  useLayerStore.setState(() => ({ layers: _layers }));
}
